import axios from 'axios';
import { API_BASE_URL } from '../../config';

const videoCaseApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

export async function getPublishedVideoCases() {
  const response = await videoCaseApi.get('video-case/list');
  const payload = response.data;

  if (payload?.code !== 200) {
    throw new Error(payload?.message || '学习与案例加载失败');
  }

  return Array.isArray(payload.data?.list) ? payload.data.list : [];
}

export async function getPublishedVideoCase(caseId) {
  const response = await videoCaseApi.get(`video-case/detail/${encodeURIComponent(caseId)}`);
  const payload = response.data;

  if (payload?.code !== 200 || !payload.data?.id) {
    throw new Error(payload?.message || '案例加载失败');
  }

  return payload.data;
}
